import { OperateurControleComponent } from './operateur-controle.component';

export const OPERATEUR_CONTROLE_ROUTES = [
    {
        path: '',
        component: OperateurControleComponent,
        data: {
            menu: {
                icon: 'chart-bar',
                libelle: 'menu.operateurs-controles'
            }
        }
    }
];
